<template>
  <div class='content-wrapper'>
    <Breadcrumb :title="$t('personalMenu-bankSettings')" />
    <div class='content-body'>
      <div class='row'>
        <div class='col-xl-8 col-lg-8 col-md-12'>
          <section class='card'>
            <div class='card-content'>
              <Bank />
            </div>
          </section>
        </div>
        <Sidebar />
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/personal/Sidebar.vue';
import Bank from '@/components/personal/Bank.vue';
import Breadcrumb from '@/components/layout/Breadcrumb';

export default {
  name: 'BankSettings',
  components: {
    Sidebar,
    Bank,
    Breadcrumb
  }
};
</script>

<style scoped></style>
